import React, { Component } from 'react'
import LeftNav from "../components/LeftNav"
import { ReactP5Wrapper } from "react-p5-wrapper";
import sketch from '../components/SketchCompressione';

export default class Compressione extends Component {
    render() {
        return(
            <div className="pageContainer">
                <LeftNav/>
                <div className="mainContent blackBg" style={{overflowY: "auto"}}>
                    <div>
                        <div className="collectionDiv">
                            <p className="collectionTitle">
                                Compressione
                            </p>
                            <a href="https://www.artblocks.io/collection/0x9800005deb3cfaf80077dbe9b9004c0020c1d6c5-3" target="_blank" rel="noopener noreferrer">
                                Available on artblocks studio
                            </a>
                            <br/><br/>
                            <div id='svgWrapper' style={{justifyContent: 'center', display: 'flex'}}>
                                <ReactP5Wrapper sketch={sketch}/>
                            </div>
                            <br/><br/>
                            <p>
                                But structures are not eternal. With the passage of time they crumble or solidify, both degenerations in opposite 
                                extremes that are the result of the apparition of a new element in the system: silence. The difference is too vast to be 
                                integrated, from pure creation through the addition of an element of absorption we obtain decay. 
                                <i>"Waste, decline, degeneration is not something to be condemned in itself: it is a necessary consequence of life, 
                                of the growth of life. The appearance of decadence is as necessary as any rise and advance of life: we have no way of eliminating it."</i>
                            </p>
                            <p>
                                Compressione is the fourth chapter of <a href="/ricercasemica">Ricerc(a)semica</a>, a journey into form and meaning of language. 
                                The algorithm explores how texts degenerates into nothingness or is generated by nothingness: silence. 
                                Two extremes that need to coexist and yet are in constant tension with each other.
                            </p>
                            <p>
                                Resolution agnostic, svg ready to be plotted, physicals available on request.
                            </p>
                            <br/><br/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}